import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

// Neutral empty / error placeholder shared by the dashboard widgets
@Component({
  selector: 'iu-widget-state',
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (state === 'error') {
      <div class="widget-state widget-state-error" role="alert" data-cy="widget-load-error">
        <i class="icon-triangle-exclamation widget-state-icon" aria-hidden="true"></i>
        <span class="widget-state-label">{{ 'widget.loadError' | translate }}</span>
        <button
          type="button"
          class="p-button p-button-secondary no-background no-border widget-state-retry"
          data-cy="widget-retry"
          (click)="onRetry($event)">
          <i class="icon-refresh" aria-hidden="true"></i>
          {{ 'widget.retry' | translate }}
        </button>
      </div>
    } @else if (state === 'noAccess') {
      <div class="widget-state" data-cy="widget-no-access">
        <i class="fa-solid fa-lock widget-state-icon" aria-hidden="true"></i>
        <span class="widget-state-label">{{ 'widget.noAccess' | translate }}</span>
      </div>
    } @else {
      <div class="widget-state" data-cy="widget-no-data">
        <i class="icon-folder widget-state-icon" aria-hidden="true"></i>
        <span class="widget-state-label">{{ 'widget.noData' | translate }}</span>
      </div>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
        width: 100%;
        min-height: 4em;
      }
      .widget-state {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.4em;
        padding: 0.5em;
        text-align: center;
        color: var(--global-label-ft-color-1);
        font-size: 0.9em;
      }
      .widget-state-icon {
        font-size: 1.4em;
        opacity: 0.6;
      }
      /* colors from the global p-button-secondary no-background rules */
      .widget-state-retry {
        gap: 0.3em;
        padding: 0.1em 0.5em;
        cursor: pointer;
      }
      .widget-state-retry:focus-visible {
        outline: 2px solid var(--global-focus-color-1);
        outline-offset: 1px;
      }
    `,
  ],
})
export class WidgetStateComponent {
  @Input() state: 'noData' | 'error' | 'noAccess' = 'noData';
  @Output() retry = new EventEmitter<void>();

  onRetry(event: MouseEvent) {
    event?.stopPropagation();
    this.retry.emit();
  }
}
